module.exports = __webpack_public_path__ + "img/pirates.min.e1b6ac84.svg";